import { useEffect, useState } from "react";
import { getMyRanking, type RankingEntry } from "../../services/dashboard-api";
import { Ranking } from "../../components/dashboard/Ranking";

/** FR-043: an employee sees only the score ranking (with its podium) for their own company —
 * nothing else a Manager's dashboard has (no charts, no per-member drill-down). */
export function EmployeeRankingPage() {
  const [entries, setEntries] = useState<RankingEntry[] | "loading">("loading");

  useEffect(() => {
    getMyRanking().then((r) => setEntries(r.ranking));
  }, []);

  return (
    <div className="mx-auto max-w-xl p-6">
      <h1 className="mb-4 font-sans text-xl text-ink">Ranking</h1>
      {entries === "loading" ? <p className="text-body">Loading…</p> : <Ranking entries={entries} />}
    </div>
  );
}
